import styled from "styled-components";

export default styled.div`
  padding: 16px;
  background-color: #f3f5f6;
`;
